import signTokenService from "../services/signTokenService";
import constants from "../constants";
import errorMessageFilter from "../filters/errorMessageFilter";
import vbAttachmentTokenService from "../services/vbAttachmentTokenService";

export default {
  data() {
    return {

    };
  },

  computed: {

  },

  methods: {
    signVbWithoutTokenImages(docId) {
      console.log('start signVbWithoutTokenImages');
      return this.getCert()
        .then(cert => this.getVbAttachmentAsBase64(docId)
          .then(response => ({
            cert: cert,
            base64String: response.data
          }))
        )
        .then(response => {
          console.log('response', response)
          return signTokenService.signPdfV2({
            fileData: response.base64String,
            certSerial: response.cert.Serial,
            signDate: "",
            fieldName: "",
            typeSign: "4",
            page: "1",
            px: "0",
            py: "0",
            pw: "1",
            ph: "1",
            imageData: constants.TRANSPARENT_BASE64
          })
        });
    },

    getCert() {
      return signTokenService
        .getCert("")
        .then(response2 => response2.data)
        .catch(() => {
          this.notify(
            "Lỗi",
            errorMessageFilter({ errorCode: "tokenCA.error" }),
            "error",
            4000
          );
        });
    },

    getVbAttachmentAsBase64(docId) {
      return vbAttachmentTokenService.downloadVbAttachmentAsBase64(docId)
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/docOutDetailMixin.js